
      import { createComponent } from '@lit/react'
      import { type EventName } from '@lit/react'
      import * as React from 'react'

      import Component from '../../components/sidenav/sidenav.component.js'
      import type { DdsItemClickEvent } from '../../events/events'
      export type { DdsItemClickEvent } from '../../events/events'

      const tagName = 'dap-ds-sidenav'

      /**
 * `dap-ds-sidenav`
 * @summary Side navigation is a list of links that are used to navigate to different sections of a page.
 * @element dap-ds-sidenav
 * @title - Side navigation
 *
 * @event {{ href: string, event: Event }} dds-item-click - Event fired when the side navigation item is clicked.
 *
 * @slot - The content of the side navigation.
 *
 * @csspart base - The main side navigation container.
 * @csspart menu - The menu of the side navigation.
 */
      const reactWrapper = createComponent({
        tagName,
        elementClass: Component,
        react: React,
        events: {
          onDdsItemClick: 'dds-item-click' as EventName<DdsItemClickEvent>
        },
        displayName: "DapDSSideNav"
      })

      export default reactWrapper
    